/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ModalidadeCaucaoCriteriaDto } from '../models/modalidade-caucao-criteria-dto';
import { ModalidadeCaucaoDto } from '../models/modalidade-caucao-dto';
import { ModalidadeCaucaoFormDto } from '../models/modalidade-caucao-form-dto';
import { ModalidadeCaucaoPageDto } from '../models/modalidade-caucao-page-dto';


/**
 * Modalidade Caução
 */
@Injectable({
  providedIn: 'root',
})
export class ModalidadeCaucaoService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getModalidadesCaucao
   */
  static readonly GetModalidadesCaucaoPath = '/modalidades-caucao';

  /**
   * Pesquisar modalidades Caução.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getModalidadesCaucao()` instead.
   *
   * This method doesn't expect any request body.
   */
  getModalidadesCaucao$Response(params?: {
    criteria?: ModalidadeCaucaoCriteriaDto;
  }): Observable<StrictHttpResponse<ModalidadeCaucaoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, ModalidadeCaucaoService.GetModalidadesCaucaoPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ModalidadeCaucaoPageDto>;
      })
    );
  }

  /**
   * Pesquisar modalidades Caução.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getModalidadesCaucao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getModalidadesCaucao(params?: {
    criteria?: ModalidadeCaucaoCriteriaDto;
  }): Observable<ModalidadeCaucaoPageDto> {

    return this.getModalidadesCaucao$Response(params).pipe(
      map((r: StrictHttpResponse<ModalidadeCaucaoPageDto>) => r.body as ModalidadeCaucaoPageDto)
    );
  }

  /**
   * Path part for operation createModalidadeCaucao
   */
  static readonly CreateModalidadeCaucaoPath = '/modalidades-caucao';

  /**
   * Criar modalidade Caução.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createModalidadeCaucao()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createModalidadeCaucao$Response(params?: {

    /**
     * apiRequest
     */
    body?: ModalidadeCaucaoFormDto
  }): Observable<StrictHttpResponse<ModalidadeCaucaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, ModalidadeCaucaoService.CreateModalidadeCaucaoPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ModalidadeCaucaoDto>;
      })
    );
  }

  /**
   * Criar modalidade Caução.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createModalidadeCaucao$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createModalidadeCaucao(params?: {

    /**
     * apiRequest
     */
    body?: ModalidadeCaucaoFormDto
  }): Observable<ModalidadeCaucaoDto> {

    return this.createModalidadeCaucao$Response(params).pipe(
      map((r: StrictHttpResponse<ModalidadeCaucaoDto>) => r.body as ModalidadeCaucaoDto)
    );
  }

  /**
   * Path part for operation getModalidadeCaucao
   */
  static readonly GetModalidadeCaucaoPath = '/modalidades-caucao/{id}';

  /**
   * Obter modalidade caução.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getModalidadeCaucao()` instead.
   *
   * This method doesn't expect any request body.
   */
  getModalidadeCaucao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ModalidadeCaucaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, ModalidadeCaucaoService.GetModalidadeCaucaoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ModalidadeCaucaoDto>;
      })
    );
  }

  /**
   * Obter modalidade caução.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getModalidadeCaucao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getModalidadeCaucao(params: {
    id: number;
  }): Observable<ModalidadeCaucaoDto> {

    return this.getModalidadeCaucao$Response(params).pipe(
      map((r: StrictHttpResponse<ModalidadeCaucaoDto>) => r.body as ModalidadeCaucaoDto)
    );
  }

  /**
   * Path part for operation updateModalidadeCaucao
   */
  static readonly UpdateModalidadeCaucaoPath = '/modalidades-caucao/{id}';

  /**
   * Atualizar modalidade Caução.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateModalidadeCaucao()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateModalidadeCaucao$Response(params: {
    id: number;
    body?: ModalidadeCaucaoFormDto
  }): Observable<StrictHttpResponse<ModalidadeCaucaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, ModalidadeCaucaoService.UpdateModalidadeCaucaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ModalidadeCaucaoDto>;
      })
    );
  }

  /**
   * Atualizar modalidade Caução.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateModalidadeCaucao$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateModalidadeCaucao(params: {
    id: number;
    body?: ModalidadeCaucaoFormDto
  }): Observable<ModalidadeCaucaoDto> {

    return this.updateModalidadeCaucao$Response(params).pipe(
      map((r: StrictHttpResponse<ModalidadeCaucaoDto>) => r.body as ModalidadeCaucaoDto)
    );
  }

  /**
   * Path part for operation ativarModalidadeCaucao
   */
  static readonly AtivarModalidadeCaucaoPath = '/modalidades-caucao/{id}/ativar';

  /**
   * Ativar modalidade Caução.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarModalidadeCaucao()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarModalidadeCaucao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ModalidadeCaucaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, ModalidadeCaucaoService.AtivarModalidadeCaucaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ModalidadeCaucaoDto>;
      })
    );
  }

  /**
   * Ativar modalidade Caução.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarModalidadeCaucao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarModalidadeCaucao(params: {
    id: number;
  }): Observable<ModalidadeCaucaoDto> {

    return this.ativarModalidadeCaucao$Response(params).pipe(
      map((r: StrictHttpResponse<ModalidadeCaucaoDto>) => r.body as ModalidadeCaucaoDto)
    );
  }

  /**
   * Path part for operation desativarModalidadeCaucao
   */
  static readonly DesativarModalidadeCaucaoPath = '/modalidades-caucao/{id}/desativar';

  /**
   * Desativar modalidade Caução.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarModalidadeCaucao()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarModalidadeCaucao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ModalidadeCaucaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, ModalidadeCaucaoService.DesativarModalidadeCaucaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ModalidadeCaucaoDto>;
      })
    );
  }

  /**
   * Desativar modalidade Caução.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarModalidadeCaucao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarModalidadeCaucao(params: {
    id: number;
  }): Observable<ModalidadeCaucaoDto> {

    return this.desativarModalidadeCaucao$Response(params).pipe(
      map((r: StrictHttpResponse<ModalidadeCaucaoDto>) => r.body as ModalidadeCaucaoDto)
    );
  }

}
